var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvalidMessage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "System Icon / Notifications / Designs / Error / Warning Triangle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20210818_Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0-BasicDetails-/-2.0-Error-DOB",
    transform: "translate(-185.000000, -337.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DOB",
    transform: "translate(185.000000, 299.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Form---Error---Desigs",
    transform: "translate(0.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-4",
    fill: "#BD2624",
    points: "12.5 0 25 25 0 25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.732,17.304 L13.268,17.304 L13.604,12.408 L13.684,10.28 L11.316,10.28 L11.396,12.408 L11.732,17.304 Z M12.5,21.192 C13.316,21.192 13.924,20.552 13.924,19.72 C13.924,18.872 13.316,18.232 12.5,18.232 C11.684,18.232 11.076,18.872 11.076,19.72 C11.076,20.552 11.684,21.192 12.5,21.192 Z",
    id: "!",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidMessage);
export default __webpack_public_path__ + "static/media/invalid-message.86ae3471c32188fd43b2c66e8317a5cd.svg";
export { ForwardRef as ReactComponent };